import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Sparkle } from "./primitives";

/**
 * Primary conversion element — the AI prompt input at the top of the hero.
 * The user's business idea is persisted to localStorage under
 * `iti.initialBusinessIdea` BEFORE we redirect to the signup page, so
 * the dashboard/AuthCallback can seed the first business idea after
 * either Google OAuth OR email/password verification.
 */
export default function HeroSearch() {
  const navigate = useNavigate();
  // If the user has ALREADY typed a prompt and been sent through the
  // signup roundtrip (e.g. auth failed and they were bounced back), we
  // rehydrate the input from localStorage so their words are still
  // visible — instead of showing an empty box and making them think
  // they lost their work. `iti.pendingPrompt` (paid-plan roundtrip)
  // wins over `iti.initialBusinessIdea` (free-plan roundtrip).
  const [idea, setIdea] = useState(() => {
    if (typeof window === "undefined") return "";
    try {
      return localStorage.getItem("iti.pendingPrompt")
          || localStorage.getItem("iti.initialBusinessIdea")
          || "";
    } catch { return ""; }
  });
  const submit = () => {
    if (idea.trim()) {
      localStorage.setItem("iti.initialBusinessIdea", idea.trim());
    }
    navigate("/signup");
  };
  return (
    <div
      className="iti-input-shell iti-input-shell--xl mx-auto max-w-4xl flex items-center gap-3 pl-6 pr-2 py-2.5"
      data-testid="hero-search"
    >
      <span className="iti-sparkle shrink-0"><Sparkle className="w-6 h-6" /></span>
      <input
        value={idea}
        onChange={(e) => setIdea(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
        data-testid="hero-idea-input"
        placeholder="Example: Create a website for a restaurant in Richmond, VA"
        className="flex-1 bg-transparent outline-none text-lg sm:text-xl py-5 text-slate-800 placeholder:text-slate-400"
      />
      <button
        onClick={submit}
        data-testid="hero-cta-btn"
        className="iti-btn-primary px-6 sm:px-8 py-4 sm:py-5 text-base font-semibold inline-flex items-center gap-2 shrink-0"
      >
        Start Building
        <ArrowRight className="w-5 h-5" />
      </button>
    </div>
  );
}
